/*****************************************************************************************************************************************************
 * Revision History
 * 2025-04-25 TBH - Updated to set pageSize from CMS (CMS Widget Page Size => Model.PageSize => HTML pageSize hidden input => JavaScript pageSize).
 *****************************************************************************************************************************************************/
export default function newsList() {
// console.log( 'newsList()' );
  return {
    newsList: [],
    tempNewsList: [],
    pageSize: -1,
    totalCount: 0,
    pageCount: 0,
    currentPage: 1,
    hasMore: false,
    currentPageURLPart: "",

    currentPageURLPartName() {
    // Get the current URL
// console.log( 'currentPageURLPartName()' );

      var currentURL = window.location.href;
// console.log( 'currentURL: ' + currentURL );

      // Extract the part after the last '/'
      var parts = currentURL.split( "/" );
      var value = parts[ parts.length - 1 ];

      if( value == "news" ) {
        this.currentPageURLPart = "";
      } else {
        this.currentPageURLPart = value;
      }
// console.log( 'return: ' + this.currentPageURLPart );
      return this.currentPageURLPart;
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
      this.bindNewsList();
    },
    prev() {
      this.currentPage = this.currentPage - 1;
      this.bindNewsList();
    },
    next() {
      this.currentPage = this.currentPage + 1;
      this.bindNewsList();
    },
    bindNewsList() {
// console.log( 'bindNewsList()' );
// console.log( 'bindEventsList(): PageSize: ' + this.pageSize + ', PageNumber: ' + this.currentPage );

      var path = this.currentPageURLPartName();

      fetch( "/api/NewsAPI/GetNewsPages"
          + "?treeNode=" + path 
          + "&pageSize=" + this.pageSize
          + "&pageNumber=" + this.currentPage,
        { method: "GET" }
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
      }).then((response) => {
// console.log( 'response: ' + JSON.stringify( response ));
        Array.prototype.push.apply( this.newsList, response.newsList );
        this.hasMore = response.hasMore;
      });
    },

    init() {
// console.log( 'init()' );
      this.pageSize = parseInt( document.getElementById( "pageSize" ).value, 10 );
// console.log( 'pageSize: ' + this.pageSize );
      this.bindNewsList();
    },
  };
}
